var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"accordion",on:{"click":function($event){$event.stopPropagation();return _vm.onClick($event)}}},[_c('p',{staticClass:"accordion__text",staticStyle:{"text-transform":"none"}},[_vm._v(_vm._s(_vm.text))]),_c('v-icon',{style:({
      'font-size': this.isPC ? '1.2em' : '1em',
    })},[_vm._v(" mdi-menu-down ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }